import { Navigate, Route, Routes } from "react-router-dom";
import { AccountCreation } from "../Pages/AccountCreation/AccountCreation";
import { AccountCreated } from "../Pages/AccountCreation/Components/AccountCreated";
import { ActiveJobs } from "../Pages/ActiveJobs/ActiveJobs";
import { Statistics } from "../Pages/AdminPages/UserManagement/Statistics";
import { UserManagement } from "../Pages/AdminPages/UserManagement/UserManagement";
import { Applications } from "../Pages/Applications/Applications";
import { Bookmarks } from "../Pages/Bookmarks/Bookmarks";
import { ClientJobPostings } from "../Pages/ClientJobPostings/ClientJobPostings";
import { Dashboard } from "../Pages/Dashboard/Dashboard";
import { JobPosting } from "../Pages/JobPosting/JobPosting";
import { AdminLogin } from "../Pages/Login/AdminLogin";
import { ResetPassword } from "../Pages/Login/Components/ResetPassword";
import { Login } from "../Pages/Login/Login";
import { MarketplaceSearch } from "../Pages/Marketplace/Components/MarketplaceSearch";
import { SeeAll } from "../Pages/Marketplace/Components/SeeAll";
import { Marketplace } from "../Pages/Marketplace/Marketplace";
import { Messages } from "../Pages/Messages/Messages";
import { ClientProfile } from "../Pages/Profile/Components/Client/ClientProfile";
import { TalentProfile } from "../Pages/Profile/Components/Talent/TalentProfile";
import { AccountInfo } from "../Pages/Settings/AccountInfo";
import { Membership } from "../Pages/Settings/Membership";
import { NotificationSettings } from "../Pages/Settings/NotificationSettings";
import { PasswordSettings } from "../Pages/Settings/PasswordSettings";
import { Policies } from "../Pages/Settings/Policies";
import { Wallet } from "../Pages/Wallet/Wallet";
import { ProtectedRoute } from "./ProtectedRoute";
import { RouteUrls } from "./RouteUrls";
import JobPostCreation from "../Pages/JobPostCreation/JobPostCreation";

export const KaziRoutes = () => {
  /* ******************** Hooks ******************** */
  /* ******************** Variables ******************** */
  /* ******************** Functions ******************** */
  /* ******************** Effects ******************** */
  /* ******************** JSX ******************** */
  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path={RouteUrls.Login} index element={<Login />} />
        <Route path='/post-creation' element={<JobPostCreation />} />
        <Route path={RouteUrls.SignUp} element={<AccountCreation />} />
        <Route path={RouteUrls.AccountCreated} element={<AccountCreated />} />
        <Route path={RouteUrls.PasswordReset} element={<ResetPassword />} />
        <Route path="/admin">
          <Route path={RouteUrls.Admin.Login} index element={<AdminLogin />} />
          <Route path="manage">
            <Route
              path={RouteUrls.Admin.Manage.Users}
              index
              element={
                <ProtectedRoute>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path={RouteUrls.Admin.Manage.Statistics}
              element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
        <Route path="/settings">
          <Route index element={<Navigate to="/settings/accountinfo" />} />
          <Route
            path={RouteUrls.Settings.AccountInfo}
            element={
              <ProtectedRoute>
                <AccountInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Settings.Password}
            element={
              <ProtectedRoute>
                <PasswordSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Settings.Membership}
            element={
              <ProtectedRoute>
                <Membership />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Settings.Notifications}
            element={
              <ProtectedRoute>
                <NotificationSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Settings.Policies}
            element={
              <ProtectedRoute>
                <Policies />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={RouteUrls.Dashboard}
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/marketplace">
          <Route
            index
            element={
              <ProtectedRoute>
                <Marketplace />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Marketplace.Posting}
            element={
              <ProtectedRoute>
                <JobPosting />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Marketplace.Search}
            element={
              <ProtectedRoute>
                <MarketplaceSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Marketplace.All}
            element={
              <ProtectedRoute>
                <SeeAll />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/profile">
          <Route
            path={RouteUrls.Profile.Client}
            element={
              <ProtectedRoute>
                <ClientProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.Profile.Talent}
            element={
              <ProtectedRoute>
                <TalentProfile />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={RouteUrls.Wallet}
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route path="/job-postings">
          <Route
            index
            element={
              <ProtectedRoute>
                <ClientJobPostings />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.JobPostings.Applications}
            element={
              <ProtectedRoute>
                <Applications />
              </ProtectedRoute>
            }
          />
          <Route
            path={RouteUrls.JobPostings.Posting}
            element={
              <ProtectedRoute>
                <JobPosting />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path={RouteUrls.Applications}
          element={
            <ProtectedRoute>
              <Applications />
            </ProtectedRoute>
          }
        />
        <Route
          path={RouteUrls.Messages}
          element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          }
        />
        <Route
          path={RouteUrls.Bookmarks}
          element={
            <ProtectedRoute>
              <Bookmarks />
            </ProtectedRoute>
          }
        />
        <Route
          path={RouteUrls.ActiveJobs}
          element={
            <ProtectedRoute>
              <ActiveJobs />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};
